import api from "@helpers/api";

import { STATUS } from "@constants/status.hrm";
import { URLS } from "@constants/urls";
import { InterchangeTransferDetailsFormDataType } from "@type/HRM/interchangeTransfer";

const { SUCCESS, FAILED } = STATUS;

const apiEndPoint = `${process.env.REACT_APP_TRANSFER_SERVICE_URL}${process.env.REACT_APP_TRANSFER_SERVICE_PORT}/${process.env.REACT_APP_TRANSFER_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EXCHANGE_TRANSFER}`;

export const getInterchangeTransfer = (() => {
  return async (id: number) =>
    api.get(`${apiEndPoint}/${id}`).then((response) => response.data);
})();

export const forwardInterchangeTransferFlow = (() => {
  return async (
    id: number,
    data: {
      status: string;
      executionerId: number;
      comments?: string;
    },
    afterEffect: (param: { data: any; status: string }) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(`${apiEndPoint}/${id}/flow-update`, {
        ...data,
      })
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });
        return {
          data: response,
        };
      });
  };
})();

export const interchangeTransfer = (() => {
  return async (
    id: number,
    data: InterchangeTransferDetailsFormDataType,
    afterEffect: (param: { data: any; status: string }) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(`${apiEndPoint}/${id}`, {
        ...data,
      })
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });
        return {
          data: response,
        };
      });
  };
})();
